module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "epi",
      "role": "doc-chapter"
    }
  }, [_c('div', {
    staticClass: "epigraph",
    attrs: {
      "role": "doc-epigraph"
    }
  }, [_c('div', {
    staticClass: "senseline"
  }, [_c('p', {
    staticClass: "epsl"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "v",
      "id": "pv",
      "role": "doc-pagebreak"
    }
  }), _vm._v("They are not long, the days of wine and roses:")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("Out of a misty dream")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("Our path emerges for a while, then closes")]), _vm._v(" "), _c('p', {
    staticClass: "epsl"
  }, [_vm._v("Within a dream.")])]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_vm._v("—Ernest Dowson, “Vitae summa brevis spem nos vetat incohare longam”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c820d6ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/wsu-scheibel-0006.vue
// module id = 69
// module chunks = 0